<template>
    <div>
        <div>
            <div class="card taskWorkList-box mb-0">
                <div class="content mb-0">
                    <div class="list-group list-custom-small list-icon-0">

                        <div class="taskWorkList-row" v-for="taskw in TaskWorkList" :key="taskw.taskWorkId" @click.prevent="openEditPage(taskw.taskWorkId)">
                            <div>
                                <i class="fa fa-hashtag color-blue2-dark ml-2"></i>
                                <span class="text-muted">{{taskw.workNo}}</span>

                                <div class="float-left">
                                    <span class="d-inline-flex align-items-center">
                                        <!--اگر کاربر تصویر پروفایل نداشت-->
                                        <!--<i class="fa fa-user-circle color-green2-light ml-2 font-30"></i>-->
                                        <!--تصویر پروفایل کاربر-->
                                        <img v-if="taskw.userImg!=null && taskw.userImg!=''" :src="taskw.userImg" alt="userProfileImg" width="30" height="30" class="rounded-circle ml-2 img-object-fit" />
                                        <i v-else class="fa fa-user-circle color-green2-light ml-2 font-30"></i>

                                        <span class="text-muted">{{taskw.registerUserTitle}}</span>
                                    </span>
                                </div>
                            </div>
                            <div>
                                <i class="fa fa-calendar text-warning ml-2"></i>
                                <span class="text-muted text-left">{{taskw.createDateTime}}</span>
                            </div>

                            <div>
                                <i class="fa fa-check color-red1-dark ml-2"></i>
                                <span class="font-weight-bold">{{taskw.workTitle}}</span>
                            </div>
                             <div>
                                <i class="fa fa-clock text-info ml-2"></i>
                                <span >زمان استفاده شده: {{taskw.workUsedTime}}</span>
                            </div>
                            <span class="float-left text-left" style="width:20%" @click.stop="deleteTaskWork(taskw.taskWorkId)"><i class="fa fa-trash color-red1-dark ml-0 font-14"></i></span>
                        </div>
                        <div v-if="Loading" class="d-flex justify-content-center w-100 py-5">
                            <div class="spinner-border color-magenta2-dark" role="status"></div>
                        </div>
                    </div>
                    <div v-if="TaskWorkList.length==0 && Loading==false">
                        <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>                        
                        <p class="text-center py-3">پیگیری برای این {{lableText('TaskName')??'وظیفه'}} ثبت نشده است</p>                        
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
import VueSimpleAlert from "vue3-simple-alert";
    export default {
        props: ['taskId', 'taskFolderId','hideDetailsButton'],
        data() {
            return {
                page: 1,
                selectedTaskWorkId: null
            };
        },
        computed: {
            TaskWorkList() {
                return this.$store.getters.GetTaskWorkList;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            }
        },
        mounted() {
            this.getTaskWorkList();
        },
        created() {
            this.getTaskWorkList();
        },
        methods: {
            getTaskWorkList() {
                this.$store.dispatch("GetTaskWorkListFromServer", {
                    pageId: this.page,
                    taskFolderId: this.$route.params.taskFolderId || this.taskFolderId
                });
            },
            showMenu(taskWorkId) {
                this.selectedTaskWorkId = taskWorkId;
            },
            openEditPage(id) {
                if (this.hideDetailsButton !== true) {
                    this.$router.push({ name: 'EditTaskWork', params: { taskWorkId: id } });
                }
            },
            deleteTaskWork(id) {
               VueSimpleAlert.confirm("آیا مایل به حذف این پیگیری هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                this.$http.get("TaskWork/Delete?id=" + id)
                    .then(data => {
                        var res = data.data;
                        if (res.includes("حذف شد")) {
                            this.page = 1;
                            this.getTaskWorkList();
                        }
                        else {
                            this.showErrorMessage(res);
                        }
                    });
                });
            }

        },

    };</script>
